module.exports = "<p>van-transfer works!</p>\r\n"